import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import MenuItem from './menu-item';
import MenuSeparator from './menu-separator';
import { SeparatorMenuItem } from './menu';
import useMenuState from './use-menu-state';
import * as styles from './submenu.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Submenu = _ref => {
  var submenuItem = _ref.item,
    labelClass = _ref.labelClass,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'column' : _ref$orientation,
    indicator = _ref.indicator,
    size = _ref.size,
    activeItem = _ref.activeItem;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  var isColumn = orientation === 'column';
  var isSelected = submenuItem.id === activeItem;
  var _useMenuState = useMenuState({
      method: isColumn ? 'click' : 'hover'
    }),
    menuOpen = _useMenuState.menuOpen,
    menuHandlerProps = _useMenuState.menuHandlerProps;
  var expander = menuOpen ? 'open' : 'closed';
  var renderItem = item => {
    if (item === SeparatorMenuItem) {
      return ___EmotionJSX(MenuSeparator, {
        orientation: orientation
      });
    }
    if ('label' in item) {
      return ___EmotionJSX(MenuItem, _extends({}, item, {
        selected: activeItem === item.id,
        size: orientation === 'row' ? 'compact' : 'full',
        indicator: indicator && orientation === 'column',
        orientation: "column",
        indent: orientation === 'column'
      }));
    }
    return null;
  };
  var buildKey = (item, index) => {
    if (item === SeparatorMenuItem) {
      return "separator-".concat(index);
    }
    return item.id;
  };
  var isChildSelected = !!submenuItem.items.find(subItem => subItem !== SeparatorMenuItem && subItem.id === activeItem);
  return ___EmotionJSX("div", {
    css: styles.submenu,
    onMouseOver: menuHandlerProps.onMouseOver,
    onFocus: () => {}
  }, 'label' in submenuItem && ___EmotionJSX(MenuItem, {
    id: submenuItem.id,
    label: submenuItem.label,
    labelClass: labelClass,
    href: getAbsoluteUrl(submenuItem.href),
    icon: submenuItem.icon,
    indicator: indicator,
    orientation: orientation,
    size: size,
    selected: menuOpen && isColumn ? isSelected : isChildSelected || isSelected,
    expander: expander,
    onExpandClick: menuHandlerProps.onClick
  }), menuOpen && ___EmotionJSX(EventBoundary, {
    data: {
      parentItem: {
        id: submenuItem.id,
        label: 'label' in submenuItem && submenuItem.label,
        href: submenuItem.href
      }
    }
  }, ___EmotionJSX("ul", {
    css: /*#__PURE__*/_css([orientation === 'row' && styles.popUpMenu])
  }, submenuItem.items.map((item, index) => ___EmotionJSX("li", {
    key: buildKey(item, index)
  }, renderItem(item))))));
};
export default Submenu;